import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AXIOS } from "../../customAxios";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logOut } from "../../reducers/auth.slice";
import { useError } from "../../context/ErrorContext";

export const logoutApi = async () => {
  const data = await AXIOS.post(`/api/logout`);
  return data;
};

export function useLogout() {
  const { handleErrorAction } = useError();
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const { mutate: logout, isLoading } = useMutation({
    mutationKey: ['logout'],
    mutationFn: () => logoutApi(),
    onSuccess: (data) => {
      // on logout api success remove all queries from cache and call logout function from auth context for removing value from localstorage.
      if (data.status === 200) {
        queryClient.removeQueries();
        dispatch(logOut())
        navigate('/logout', { replace: true })
      }
    },
    onError: (error: Error) => {
      handleErrorAction(error)
    }
  });

  return { logout, isLoading };
}